module.exports = __webpack_public_path__ + "static/media/19.0a108bb4.jpeg";